<template>
  <el-dialog :visible.sync="visible" title="设置实际发票号" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="自定义发票号：" >
        <el-input type="text" v-model="dataForm.virtualCode" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="进出口发票号：" prop="realCode">
        <el-input type="text" v-model="dataForm.realCode"></el-input>
      </el-form-item>
      <el-form-item label="领用人：" >
        <el-input v-model="dataForm.useManName"  :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="领用时间：" >
        <el-input v-model="dataForm.useTime"  :disabled="true"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isInt } from '@/utils/validate'
import CommonDrop from '@/components/CommonDrop'
import moment from 'moment'
export default {
  components:{CommonDrop},
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {

      }
    }
  },
  computed: {
    dataRule () {
      return {
        realCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        virtualCode: '',
        realCode:'',
        useTime: '',
        useManName:'',
        remark:''
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init (id) {
      this.reset()
      this.id=id
      this.getInfo()
      this.visible = true
    },
    async getInfo(){
      const {data:res}=await this.$http.get(`/trade/code/${this.id}`)
      if(res.code!=0){
        return this.$message.error(res.msg)
      }
      this.dataForm={
        ...this.dataForm,
        ...res.data
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          id:this.dataForm.id,
          realCode:this.dataForm.realCode
        }
        this.$http.put('/trade/code', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
